import React from "react";
import Alerts from "../components/Alerts";

export default function AlertsPage() {
  return (
    <>
      <Alerts />
    </>
  );
}
